var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWebsite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2C3149;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.8,3C9.6,3,3,9.7,3,18c0,8.3,6.6,15,14.8,15c8.2,0,14.8-6.7,14.8-15C32.6,9.7,26,3,17.8,3z M28.1,25.8 c-1.2-0.7-2.5-1.3-3.9-1.8c0.3-1.5,0.5-3.2,0.5-5h5.9C30.4,21.5,29.5,23.8,28.1,25.8L28.1,25.8z M5,19h5.9c0,1.8,0.2,3.5,0.5,5 c-1.4,0.4-2.7,1-3.9,1.8C6.1,23.8,5.2,21.5,5,19L5,19z M7.5,10.2c1.2,0.7,2.5,1.3,3.9,1.8c-0.3,1.5-0.5,3.2-0.5,5H5 C5.2,14.5,6.1,12.2,7.5,10.2L7.5,10.2z M21.8,10.6c-1.3,0.3-2.6,0.4-4,0.4s-2.7-0.1-4-0.4c1-3.5,2.5-5.6,4-5.6S20.9,7.1,21.8,10.6z  M21.9,5.7c1.9,0.6,3.5,1.7,4.9,3c-1,0.5-2,1-3,1.3C23.3,8.3,22.6,6.8,21.9,5.7z M12.9,17c0-1.6,0.2-3.1,0.5-4.5 c1.4,0.3,2.9,0.5,4.5,0.5c1.5,0,3-0.2,4.5-0.5c0.3,1.4,0.4,2.9,0.5,4.5H12.9z M22.7,19c0,1.6-0.2,3.1-0.5,4.5 c-1.4-0.3-2.9-0.5-4.5-0.5c-1.5,0-3,0.2-4.5,0.5c-0.3-1.4-0.4-2.9-0.5-4.5H22.7z M11.9,10c-1.1-0.4-2.1-0.8-3-1.3 c1.4-1.4,3.1-2.4,4.9-3C13,6.8,12.4,8.3,11.9,10z M11.9,26c0.5,1.7,1.1,3.2,1.9,4.4c-1.9-0.6-3.5-1.7-4.9-3 C9.8,26.8,10.8,26.3,11.9,26z M13.8,25.4c1.3-0.3,2.6-0.4,4-0.4s2.7,0.1,4,0.4c-1,3.5-2.5,5.6-4,5.6C16.4,31,14.8,28.9,13.8,25.4z  M23.7,26c1.1,0.4,2.1,0.8,3,1.3c-1.4,1.4-3.1,2.4-4.9,3C22.6,29.2,23.3,27.7,23.7,26z M24.7,17c0-1.8-0.2-3.5-0.5-5 c1.4-0.4,2.7-1,3.9-1.8c1.4,1.9,2.3,4.2,2.5,6.8L24.7,17z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWebsite);
export default __webpack_public_path__ + "static/media/icon-website.7d43409a84d33b7b49bd9316d7fbcf24.svg";
export { ForwardRef as ReactComponent };